import type { QueueListItem } from "../api/client";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import { maskPhoneNumber } from "./WorkerStatusBanner";
import { NotificationDetailTextCell } from "./NotificationDetailTextCell";
import {
  formatNotificationDateTime,
  QueueStatusBadge,
  TriggerBadge,
} from "./notification-table-badges";

export function NotificationQueueTable({
  items,
  hasActiveFilter,
}: {
  items: QueueListItem[];
  hasActiveFilter?: boolean;
}) {
  return (
    <div className="overflow-x-auto rounded-lg border">
      <Table className="min-w-[960px]">
        <TableHeader>
          <TableRow className="bg-muted/40 hover:bg-muted/40">
            <TableHead className="w-[7.5rem]">ເວລາ</TableHead>
            <TableHead className="min-w-[9rem]">ນັກຮຽນ</TableHead>
            <TableHead>Trigger</TableHead>
            <TableHead>ສະຖານະ</TableHead>
            <TableHead>ເບີ</TableHead>
            <TableHead className="min-w-[12rem]">ຂໍ້ຄວາມ</TableHead>
            <TableHead className="min-w-[12rem]">ຂໍ້ຜິດພາດ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} className="py-12 text-center">
                <p className="font-medium text-muted-foreground">
                  ບໍ່ມີລາຍການໃນຄິວ
                </p>
                {hasActiveFilter ? (
                  <p className="mt-1 text-muted-foreground text-sm">
                    ລອງປັບກັ່ນຕົວສະຖານະ
                  </p>
                ) : null}
              </TableCell>
            </TableRow>
          ) : (
            items.map((item) => (
              <TableRow key={item.id} className="hover:bg-muted/20">
                <TableCell className="whitespace-nowrap tabular-nums text-sm">
                  {formatNotificationDateTime(item.createdAt)}
                </TableCell>
                <TableCell>
                  <div className="font-medium">
                    {item.studentName ?? item.studentId}
                  </div>
                  {item.memberId ? (
                    <div className="text-muted-foreground text-xs tabular-nums">
                      {item.memberId}
                    </div>
                  ) : null}
                </TableCell>
                <TableCell>
                  <TriggerBadge triggerType={item.triggerType} />
                </TableCell>
                <TableCell>
                  <QueueStatusBadge status={item.status} />
                </TableCell>
                <TableCell className="font-mono text-sm">
                  {maskPhoneNumber(item.phoneNumber)}
                </TableCell>
                <TableCell className="align-top">
                  <NotificationDetailTextCell
                    text={item.messageBody}
                    dialogTitle="ຂໍ້ຄວາມທີ່ຈະສົ່ງ"
                  />
                </TableCell>
                <TableCell className="align-top">
                  <NotificationDetailTextCell
                    text={item.lastError}
                    dialogTitle="ຂໍ້ຜິດພາດ"
                    variant="error"
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
